module.exports = __webpack_public_path__ + "2bdf4c34d66ae7229155938f10c15e8b.pdf";